export default "__VITE_ASSET__DyILNVfK__"